import { render, staticRenderFns } from "./FolderDropdown.vue?vue&type=template&id=5f05bd96&scoped=true"
import script from "./FolderDropdown.vue?vue&type=script&lang=js"
export * from "./FolderDropdown.vue?vue&type=script&lang=js"
import style0 from "./FolderDropdown.vue?vue&type=style&index=0&id=5f05bd96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f05bd96",
  null
  
)

export default component.exports